import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { Component } from "react";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import FetchServerData from "../../../provider/FetchServerData";
import {
  ForgetPassword_Url,
  Login_Url,
  LOGIN_WITH_GMAIL,
  RmGmailLogin_Url,
  RmLogin_Url,
  Static_Url,
  StaticEventText_Url,
  TenantList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import headerAction from "../../../redux/header/headerAction";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
import logo from "../../website/home/assets/img/givbeeLogo.png";
import "./Signin.css";
import PtsAlert from "../ptsAlert/PtsAlert";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";

export class Signin extends Component {
  debounceTimeout = null;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      googleToken: "",
      clientId: "",
      showPassword: false,
      showConfirmPassword: false,
      rememberMe: false,
      isTenantCheckbox: false,
      tenantList: [],
      tenantId: null,
      user: null,
      isCompany: false,
      resendOtpByEmail: false,
      resendOtpByText: false,
      sendOtpByEmail: false,
      sendOtpByText: true,
      isAuthenticated: false,
      error: false,
    };
  }

  componentDidMount() {
    store.dispatch(staticDataAction.setStaticData({}));
    store.dispatch(headerAction.setHeader({}));
    store.dispatch(AppUserDataAction.setUserData({}));
    store.dispatch(AppUserDataAction.setLogo({}));
    store.dispatch(ActiveMenuAction.setActiveMenu({}));
    store.dispatch(SelectedTabAction.setSelectedTab(""));
    store.dispatch(SelectedDomainAction.setSelectedDomain(""));
    store.dispatch(SelectedDomainAction.setEventState({}));
    store.dispatch(AccountSettingDataAction.setAccountSettingData({}));
    store.dispatch(CrmIntegrationAction.setCrmIntegration(""));
    store.dispatch(PaginationRowAction.setSendHistoryPaginationState({}));
    store.dispatch(PaginationRowAction.setSheduledSendPaginationState({}));
    store.dispatch(PaginationRowAction.setOptinsPaginationState({}));
    store.dispatch(PaginationRowAction.setPaindingPaginationState({}));
    store.dispatch(PaginationRowAction.setOptoutPaginationState({}));
    store.dispatch(PaginationRowAction.setInvalidPaginationState({}));
    store.dispatch(PaginationRowAction.succSendMsgStatsPaginationState({}));
    store.dispatch(PaginationRowAction.textResponseMsgStatsPaginationState({}));
    store.dispatch(PaginationRowAction.paymentShortLinkPaginationState({}));

    // Retrieve browser name
    const browserName = Utils.getBrowserType();

    // Retrieve stored credentials if "Remember Me" was checked
    const storedHeader = JSON.parse(localStorage.getItem("header"));
    const storedGmailHeader = JSON.parse(localStorage.getItem("gmailHeader"));
    const storedBrowser = localStorage.getItem("browserType");
    // const storedUserId = localStorage.getItem("userId");
    // const storedPassword = localStorage.getItem("password");
    // const storedGoogleToken = localStorage.getItem("googleToken");
    // const storedTenantId = localStorage.getItem("selectedOption");
    const rememberMeFlag = localStorage.getItem("rememberMe");
    if (storedBrowser === browserName) {
      if (rememberMeFlag && storedGmailHeader) {
        this.rmEmailLoginInBackend(
          storedGmailHeader,
        );
      }
      if (rememberMeFlag && storedHeader) {
        this.setState({
          rememberMe: rememberMeFlag,
          render: false,
        });
        this.rmLoginInBackend(
          storedHeader,
        );
      }
    } else {
      localStorage.removeItem("header");
      localStorage.removeItem("gmailHeader");
      localStorage.removeItem("userId");
      localStorage.removeItem("password");
      localStorage.removeItem("googleToken");
      localStorage.removeItem("selectedOption");
      localStorage.removeItem("rememberMe");
      localStorage.setItem("browserType", browserName);
    }
  }
  getTenantList(email) {
    if (Utils.emailValidation(email)) {
      const postObject = {
        header: {
          userid: email,
        },
      };
      FetchServerData.callPostService(TenantList_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
            let tenantList = output.data;
            let tenantId = Utils.getArrayElement(tenantList, 0);
            // if (this.state.rememberMe) {
            //   localStorage.setItem(
            //     "selectedOption",
            //     JSON.stringify(tenantList[0])
            //   );
            // } else {
            //   localStorage.removeItem("selectedOption");
            // }

            if (tenantList.length > 1) {
              this.setState({
                render: true,
                email: this.state.email,
                tenantList: tenantList,
                tenantId: tenantId,
                isCompany: true,
              });
            } else {
              this.setState({
                isCompany: false,
                tenantList: tenantList,
                tenantId: tenantId,
              });
            }
          } else {
          }
        }
      );
    } else {
      if (email !== "" || email.length > 0) {
        PtsAlert.error("Enter valid User ID format john.doe@email.com");
      }
    }
  }

  handleEmailChange(e) {
    let val = e.target.value;
    this.setState({ email: val });

    if (val.trim() === "") {
      this.setState({ isCompany: false });
    }

    // Clear previous timer
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set new debounce timer
    this.debounceTimeout = setTimeout(() => {
      const domainRegex = /\.[a-zA-Z]{2,}$/;
      if (domainRegex.test(val)) {
        this.getTenantList(val);
      }
    }, 800);
  }
  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleCheckboxChange = () => {
    this.setState((prevState) => ({ rememberMe: !prevState.rememberMe }));
  };

  handleCompanyChange(selectedValue) {
    this.state.tenantId = selectedValue;
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    this.setState({ tenantId: selectedValue });
  }

  loginInBackend = (e) => {
    // Clear credentials if "Remember Me" is unchecked
    let header = {
      email: this.state.email,
      tid: this.state.tenantId?.id,
      appclient: "W",
    };

    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        isRememberMe: this.state.rememberMe,
      },
    };

    FetchServerData.callPostService(Login_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = output.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          // this.getAccountSettingData(output.header);
          // const browserName = Utils.getBrowserType();
          // if (appuser.isRememberMe) {
          //   localStorage.setItem("userId", this.state.email);
          //   localStorage.setItem("password", this.state.password);
          //   localStorage.setItem(
          //     "selectedOption",
          //     JSON.stringify(this.state.tenantId)
          //   );
          //   localStorage.setItem("rememberMe", appuser.isRememberMe);
          //   localStorage.setItem("browserType", browserName);
          // }
          if (appuser.isPwdresetRequested) {
            this.forgotPasswordBackend(appuser.isPwdresetRequested);
            // this.props.navigate("/resetPassword", {
            //   state: {
            //     email: this.state.email,
            //     tenantId: this.state.tenantId,
            //     tenantList: this.state.tenantList,
            //   },
            // });
          } else {
            this.props.navigate("/verifyotp", {
              state: {
                businessDomain: output?.appuser?.businessDomain,
                resendOtpByEmail: output?.appuser?.sendOtpByEmail,
                resendOtpByText: output?.appuser?.sendOtpByText,
                sendOtpByEmail: output?.appuser?.sendOtpByEmail,
                sendOtpByText: output?.appuser?.sendOtpByText,
                rememberMe: this.state.rememberMe,
                password: this.state.password,
              },
            });
          }
        }
      })
      .catch((error) => { });
  };

  forgotPasswordBackend(isPwdresetRequested) {
    let header = { email: this.state.email, tid: this.state.tenantId?.id };
    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        // sendOtpByEmail: this.state.sendOtpByEmail,
        // sendOtpByText: this.state.sendOtpByText,
      },
    };

    FetchServerData.callPostService(ForgetPassword_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/resetPassword", {
            state: {
              email: this.state.email,
              tenantId: this.state.tenantId,
              tenantList: this.state.tenantList,
              isPwdresetRequested: isPwdresetRequested,
            },
          });
        } else {
          if (output.status === "FAIL") {
            PtsAlert.error("Please enter Registered User Id");
          }
        }
      })
      .catch((error) => { });
  }

  rmLoginInBackend = (header) => {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(RmLogin_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = response.data?.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          this.processLoginSuccess(output);
          const browserName = Utils.getBrowserType();
          if (appuser.isRememberMe) {
            localStorage.setItem("rememberMe", appuser.isRememberMe);
            localStorage.setItem("browserType", browserName);
            localStorage.setItem("header", JSON.stringify(output.header));
          }
        }
      })
      .catch((error) => { });
  };

  processLoginSuccess(output_data) {
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
    let logoData = {
      logo: output_data.appuser?.organization?.logo
        ? output_data.appuser?.organization?.logo
        : "",
      logoFilename: output_data.appuser?.organization?.logoFilename
        ? output_data.appuser?.organization?.logoFilename
        : "",
      logoFileextension: output_data.appuser?.organization?.logoFileextension
        ? output_data.appuser?.organization?.logoFileextension
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    store.dispatch(SelectedTabAction.setSelectedTab(0));
    // if (output_data.isTollfreeNumberPurchased === true) {
    //   store.dispatch(SelectedTabAction.setSelectedTab(0));
    // } else {
    //   store.dispatch(SelectedTabAction.setSelectedTab(1));
    // }
    let header = this.header;
    this.loadDashboardPage(header, output_data);
  }
  async loadDashboardPage(header, output) {
    let menus = output.appuser?.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    await this.setStaticData(header);
    store.dispatch(
      ActiveMenuAction.setActiveMenu(Utils.getArrayElement(menus, 0)?.pageid)
    );
    // this.props.navigate("/dashboard", {
    //   state: {
    //     render: true,
    //     email: this.state.email,
    //     pageId: "login",
    //     //  tenantList: tenantList,
    //   },
    // });

    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }
  async setStaticData(header) {
    let StaticUrl = Utils.equalsIgnoreCase(
      this.state.businessDomain,
      BUSINESS_DOMAIN.eventText
    )
      ? StaticEventText_Url
      : Static_Url;
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(StaticUrl, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData(output.data));
      } else {
      }
    });
  }

  signInWithGoogleInBackend = (e) => {
    let header = {
      email: this.state.email,
      tid: this.state.tenantId.id,
      appclient: "W",
    };
    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        googleToken: this.state.googleToken,
        isRememberMe: this.state.rememberMe,
      },
    };

    FetchServerData.callPostService(LOGIN_WITH_GMAIL, postObject)
      .then((response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          let appuser = output.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          this.getAccountSettingData(output.header);
          const browserName = Utils.getBrowserType();
          if (appuser.isRememberMe) {
            // localStorage.setItem("userId", this.state.email);
            // localStorage.setItem("googleToken", this.state.googleToken);
            localStorage.setItem("rememberMe", appuser?.isRememberMe);
            localStorage.setItem("browserType", browserName);
            localStorage.setItem("gmailHeader", JSON.stringify(output.header));
          }
          this.processLoginSuccess(output);
        } else {
        }
      })
      .catch((error) => { });
  };

  rmEmailLoginInBackend = (header) => {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(RmGmailLogin_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = output.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          this.processLoginSuccess(output);
          const browserName = Utils.getBrowserType();
          if (appuser.isRememberMe) {
            localStorage.setItem("rememberMe", appuser?.isRememberMe);
            localStorage.setItem("browserType", browserName);
            localStorage.setItem("gmailHeader", JSON.stringify(output.header));
          }
        }
      })
      .catch((error) => { });
  };

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  handleSuccess = (credentialResponse) => {
    const googleToken = credentialResponse.credential; // This is the idToken
    const userObject = JSON.parse(atob(googleToken.split(".")[1]));
    if (userObject.email.endsWith(".com")) {
      this.getTenantList(userObject.email);
    }

    if (userObject) {
      this.setState({
        googleToken: googleToken,
        email: userObject.email,
        isAuthenticated: true,
      });
    } else {
    }
  };

  handleError = () => {
    console.error("Login Failed");
  };

  getClientIdInBackend = (e) => {
    const postObject = {
      header: {},
    };

    FetchServerData.callPostService("/staticms/getClientId", postObject)
      .then((response) => {
        if (response.status === "SUCCESS") {
          let clientId = response.data.clientId;
          this.setState({
            clientId: clientId,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  };

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          {/* /Left Text */}
          <div
            className="d-flex col-12 col-lg-6 col-xl-6 align-items-center leftBackground"
            style={{ textAlign: "center", background: "rgb(55, 81, 126)" }}
          >
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          {/* /Left Text */}
          {/* Register */}
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <div className="signinHeding">Sign In</div>
              {!this.state.isAuthenticated ? (
                <ValidatorForm
                  ref="form"
                  id="formAuthentication"
                  className="mb-3"
                  onSubmit={this.loginInBackend.bind(this)}
                >
                  <div className="mb-3">
                    <label className="form-label" htmlFor="multiStepsEmail">
                      User ID{" "}
                      <span className="fw-normal">(email address)</span>
                    </label>
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="email"
                      name="userId"
                      value={this.state.email}
                      onChange={this.handleEmailChange.bind(this)}
                      id="multiStepsEmail"
                      className="form-control"
                      aria-label="john.doe"
                    />{" "}
                  </div>
                  {this.state.isCompany && (
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="multiStepsLastName"
                      >
                        Company name
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.tenantList}
                        value={this.state.tenantId}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.tenantId}
                        onChange={(event, value) => {
                          this.handleCompanyChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Company name"
                            name="selectedOption"
                            variant="outlined"
                            size="small"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  )}
                  <div className="mb-3 form-password-toggle">
                    <label className="form-label" htmlFor="multiStepsPass">
                      Password{" "}
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        className="form-control"
                        aria-describedby="multiStepsPass2"
                        onChange={this.handlePasswordChange.bind(this)}
                        value={this.state.password}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        id="multiStepsPass2"
                        onClick={this.handleClickShowPassword.bind(this)}
                      >
                        {this.state.showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </span>
                    </div>
                  </div>
                  {/* <div className="row d-flex">
                      <div className="col-md-6 d-flex">
                        <label className="form-label" htmlFor="multiStepsPass">
                          Send verification code to:
                        </label>
                      </div>
                      <div className="col-md-3 d-flex">
                        <span className="me-1" style={{ marginTop: "2px" }}>
                          <input
                            type="checkbox"
                            style={{ cursor: "pointer" }}
                            value={this.state.sendOtpByText}
                            onChange={(e) => this.handleSendOtpByTextChange(e)}
                            checked={this.state.sendOtpByText}
                          />
                        </span>
                        <p
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          mobile
                        </p>
                      </div>
                      <div className="col-md-3 d-flex">
                        <span className="me-1" style={{ marginTop: "2px" }}>
                          <input
                            type="checkbox"
                            style={{ cursor: "pointer" }}
                            value={this.state.sendOtpByEmail}
                            onChange={(e) => this.handleSendOtpByEmailChange(e)}
                            checked={this.state.sendOtpByEmail}
                          />
                        </span>
                        <p
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          email
                        </p>
                      </div>
                      {this.state.error ? (
                        <lable className="danger" style={{ color: "red" }}>
                          Please Select checkbox
                        </lable>
                      ) : (
                        ""
                      )}
                    </div> */}
                  <div className="row mb-2 d-flex">
                    <div className="col-md-12 d-flex rememberMeCheckbox">
                      <FormControlLabel
                        style={{
                          width: "60%",
                          margin: "0",
                          padding: "0",
                          alignItems: "flex-start",
                        }}
                        control={
                          <Checkbox
                            variant="outlined"
                            id="rememberMe"
                            checked={this.state.rememberMe}
                            onChange={this.handleCheckboxChange.bind(this)}
                            style={{
                              background: "none",
                            }}
                          />
                        }
                        label={
                          <span
                            className="form-label fw-normal"
                            style={{
                              fontSize: "14px",
                              margin: "0 8px 0 4px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                              lineHeight: "1.2",
                            }}
                          >
                            Remember me on this device
                          </span>
                        }
                      />
                    </div>
                  </div>
                  <button className="siginButton d-grid w-100" type="submit">
                    Sign in
                  </button>
                </ValidatorForm>
              ) : (
                <ValidatorForm
                  ref="form"
                  id="formAuthentication"
                  className="mb-3"
                  onSubmit={this.signInWithGoogleInBackend.bind(this)}
                >
                  <div className="mb-3">
                    <label className="form-label" htmlFor="multiStepsEmail">
                      User ID{" "}
                      <span className="fw-normal">(email address)</span>
                    </label>
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="email"
                      name="userId"
                      value={this.state.email}
                      onChange={this.handleEmailChange.bind(this)}
                      id="multiStepsEmail"
                      className="form-control"
                      aria-label="john.doe"
                    />{" "}
                  </div>
                  {this.state.isCompany && (
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="multiStepsLastName"
                      >
                        Company name
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.tenantList}
                        value={this.state.tenantId}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.tenantId}
                        onChange={(event, value) => {
                          this.handleCompanyChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Company name"
                            name="selectedOption"
                            variant="outlined"
                            size="small"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  )}
                  <div className="row mb-2 d-flex">
                    <div className="col-md-12 d-flex">
                      <span style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          checked={this.state.rememberMe}
                          name="rememberMe"
                          onChange={this.handleCheckboxChange.bind(this)}
                        />
                      </span>
                      <label className="form-label ms-1 fw-normal">
                        Remember me
                      </label>
                    </div>
                  </div>
                  <button
                    className="siginButton d-grid w-100 mt-4"
                    type="submit"
                  >
                    Sign in
                  </button>
                </ValidatorForm>
              )}
              <div className="d-flex flex-row">
                <div class="col-md-4 align-self-start">
                  <NavLink to="/forgotPassword">
                    <span>Forgot Password?</span>
                  </NavLink>
                </div>
                <div class="col-md-8 align-self-end">
                  <p className="text-end">
                    <span>Need an account?</span>&nbsp;
                    <NavLink to="/signup">
                      <span>Sign Up</span>
                    </NavLink>
                  </p>
                </div>
              </div>
              <hr></hr>
              <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <span
                    style={{ opacity: "none", cursor: "pointer" }}
                    onClick={this.getClientIdInBackend.bind(this)}
                  >
                    <GoogleOAuthProvider
                      clientId={this.state.clientId}
                    // onScriptLoadSuccess={this.getClientIdInBackend.bind(
                    //   this
                    // )}
                    >
                      <div style={{ textAlign: "center", marginTop: "20px" }}>
                        {!this.state.isAuthenticated && (
                          <GoogleLogin
                            onSuccess={this.handleSuccess.bind(this)}
                            onFailure={this.handleError.bind(this)}
                            redirectUri="http://localhost:3000/signin"
                          />
                        )}
                      </div>
                    </GoogleOAuthProvider>
                  </span>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Signin);
